import { SVGProps } from 'react';

export const LocationPinIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4.5 8.672C4.5 4.679 7.894 1.5 12 1.5s7.5 3.18 7.5 7.172c0 2.25-1.217 5.036-2.55 7.444-1.354 2.443-2.912 4.644-3.747 5.773a1.489 1.489 0 0 1-2.406 0c-.835-1.13-2.393-3.332-3.747-5.775C5.717 13.706 4.5 10.92 4.5 8.672ZM12 3C8.652 3 6 5.577 6 8.672c0 1.829 1.033 4.314 2.363 6.715 1.306 2.359 2.819 4.5 3.637 5.605.818-1.105 2.331-3.244 3.637-5.603C16.967 12.988 18 10.502 18 8.672 18 5.577 15.348 3 12 3Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9.879 6.879a3 3 0 1 1 4.242 4.243A3 3 0 0 1 9.88 6.879ZM12 10.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
      clipRule="evenodd"
    />
  </svg>
);
